import debug from 'debug';
import { useState, useEffect } from 'react';
import { get } from '../../../lib/crossover';
import { toast } from 'react-toastify';

const log = debug('pivot:cache');

// WARNING: this is a cache for all keys and components
const CACHE = {};
const PROMISES = {};

/**
 *
 * @param {String} url - the url to obtain the data
 * @example
 * const data = useGET(url, () => fetch(url))
 */
export function useGET(url) {
  const [data, setValue] = useState(CACHE[url]);
  let isMounted = true;

  useEffect(() => {
    if (!url) return () => {};
    if (CACHE[url]) {
      setValue(CACHE[url]);
    } else {
      log('Retrieve %s', url);
      if (isMounted) setValue(undefined);
      // we cache promises to avoid same GET request twice
      PROMISES[url] = PROMISES[url] || Promise.resolve(get(url));
      PROMISES[url]
        .then(data => {
          log('Data for %s', url);
          PROMISES[url] = null;
          CACHE[url] = data;
          if (isMounted) setValue(CACHE[url]);
        })
        .catch(() => {
          toast('Error loading data or no data available', {
            className: 'toast-error',
          });
        });
    }
    return () => {
      log('unmount %s', url);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      isMounted = false;
    };
  }, [url]);

  return data;
}
